<div mat-dialog-content class="h-full flex flex-col gap-4">
    <div class="flex flex-row justify-between items-start">
        <h2 mat-dialog-title>Inactive Tags</h2>
        @if (!loading && dataSource.data.length !== 0) {
            <mat-form-field>
                <mat-label>Filter data</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input />
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        }
    </div>
    @if (!loading) {
        @if (dataSource.data.length === 0) {
            <myrtls-info-card [type]="'success'"> All tags are active. No action is required. </myrtls-info-card>
        }
        <div class="table-container flex-grow overflow-auto">
            @if (dataSource.data.length !== 0) {
                <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="alias" sticky>
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">Alias</th>
                        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">{{ element.alias }}</td>
                    </ng-container>
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>MAC</th>
                        <td mat-cell *matCellDef="let element">{{ element.title }}</td>
                    </ng-container>
                    <ng-container matColumnDef="platform">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">Tag Type</th>
                        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
                            <span class="px-3 py-1 bg-light-200 rounded-md text-sm">
                                {{ element.platform }}
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="px-3 py-1 bg-warning rounded-md text-white text-sm">{{ element.status | uppercase }}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="inactiveFor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inactive For</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.inactiveFor }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columns" class="font-semibold"></tr>
                    <tr mat-row *matRowDef="let element; columns: columns"></tr>
                </table>
            }
        </div>
        @if (dataSource.data.length !== 0) {
            <myrtls-info-card [type]="'warning'">
                If possible please locate the tags, turn them ON and make sure they are in RTLS area.
            </myrtls-info-card>
        }
    } @else {
        <div class="w-full flex justify-center items-center">Loading...</div>
    }
</div>
<div class="flex items-center justify-end" mat-dialog-actions>
    <button mat-button mat-dialog-close>CLOSE</button>
</div>
